import React, { useEffect, useState } from "react";
import "../component/style.css";
import { UserApi } from "../apis";
import Header from "../component/header";
import SideNav from "../component/sideNav";
import PropTypes from "prop-types";
import { Box, Button, TextField, Alert } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";
import CustomInputLabel from "../component/customInputLabel";
import CustomPasswordInput from "../component/customPasswordInput";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../component/customInput";
import { updateUser } from "../reducer/user.reducer";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const Settings = () => {
  const user = useSelector((state) => state?.conUser?.user);
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [name, setName] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [state, setState] = useState("");
  const [postalcode, setPostalCode] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [profileImg, setProfileImg] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [message, setMessage] = useState("");

  const [nameErr, setNameErr] = useState("");

  const SettingRouter = UserApi();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    getInformation();
    if (showAlert) {
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
      }, 10000);
      return () => {
        clearTimeout(timeoutId);
      };
    }
    // eslint-disable-next-line
  }, [showAlert]);

  const getInformation = async () => {
    try {
      setName(user?.name);
      setPhoneNo(user?.phone);
      setProfileImg(user?.profile_picture);
      setEmail(user?.email);
      setCity(user?.city);
      setAddress(user?.address);
      setState(user?.state);
      setPostalCode(user?.postalcode);
    } catch (error) {
      console.log("Admins ", error);
    }
  };

  const updateSettings = async () => {
    if (!name) {
      setNameErr("name is required");
      return false;
    }
    try {
      const updateData = new FormData();

      updateData.append("name", name);
      updateData.append("email", email);
      updateData.append("phone", phoneNo);
      updateData.append("city", city);
      updateData.append("address", address);
      updateData.append("state", state);
      updateData.append("postalcode", postalcode);
      if (profilePic) {
        updateData.append("profile_picture", profilePic);
      }
      const res = await SettingRouter.update(updateData, user?._id);
      if (res?.status !== 200 && res?.status !== 201) {
        const msg =
          res?.error?.response?.data?.message ||
          "unknown error occur during user update Info";
        setMessage(msg);
        setAlertType("error");
        setShowAlert(true);
      } else {
        const getDetail = await SettingRouter.getDetails();
        const data = getDetail?.data;
        dispatch(updateUser(data));
        const msg = res?.data?.message
        setMessage(msg);
        setAlertType("success");
        setShowAlert(true);
      }
    } catch (error) {
      console.log("Settings", error);
    }
  };

  const resetPassword = async () => {
    const isValid = validate();

    if (!isValid) return null;
    if (newPassword === confirmPassword) {
      setPasswordMatch(true);
      try {
        const res = await SettingRouter.resetPassword({
          email: email,
          oldPassword,
          newPassword,
        });
        if (res?.status !== 200 && res?.status !== 201) {
          const msg =
            res?.error?.response?.data?.message ||
            "unknown error occur during password update/reset";
          setMessage(msg);
          setAlertType("error");
          setShowAlert(true);
        } else {
          setShowAlert(true);
          setMessage(res.data.message);
          setOldPassword("");
          setNewPassword("");
          setConfirmPassword("");
          setAlertType("success");
        }
      } catch (error) {
        setShowAlert(true);
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          setMessage(error.response.data.message); // Error from server
          console.log("Error message:", error.response.data.message);
        }
      }
    } else {
      setPasswordMatch(false);
    }
  };

  const validate = () => {
    let isValid = true;
    const regex =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{6,}$/;

    if (!oldPassword || !newPassword || !confirmPassword) {
      setMessage("All fields are required");
      isValid = false;
    } else if (!regex.test(newPassword)) {
      setMessage(
        "Your password must be at least 6 characters long and include:\n- At least one uppercase letter\n- At least one lowercase letter\n- At least one number\n- At least one special character (!@#$%^&*)"
      );
      isValid = false;
    } else if (newPassword !== confirmPassword) {
      setMessage(
        "Password do not match. Please ensure both New password and confirm password fields contain the same password."
      );
      isValid = false;
    }

    if (!isValid) {
      setAlertType("error");
      setShowAlert(true);
    }

    return isValid;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setProfileImg(reader.result);
        setProfilePic(file);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="mainContainer">
      <Header></Header>
      <SideNav active="Settings"></SideNav>
      <div
        className="contentBox"
        style={{
          gap: "10px",
          position: "relative",
        }}
      >
        <h6>
          <i className="bi bi-gear-fill" />
          Account Settings
        </h6>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
          }}
        >
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            sx={{ borderRight: 1, borderColor: "divider" }}
          >
            <Tab label="General         " {...a11yProps(0)} />
            <Tab label="Reset Password" {...a11yProps(1)} />
            {/* <Tab label="Delete Account" {...a11yProps(2)} /> */}
          </Tabs>
          <TabPanel value={value} index={0}>
            <Grid
              container
              size={{ sm: 6, xm: 6, md: 6 }}
              sx={{ margin: "0 auto", minWidth: 340 }}
            >
              <Grid size={{ sm: 12, xs: 12, md: 12 }}>
                <h5>Personal Information</h5>
                <CustomInput
                  name="name"
                  title="Name"
                  type="text"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    setNameErr("");
                  }}
                  required={nameErr.length > 0 ? true : false}
                  helperText={nameErr}
                  placeholder="enter name"
                  width="100%"
                />
                <CustomInputLabel title={"Phone Number"} isRequired={false} />
                <TextField
                  value={phoneNo}
                  margin="dense"
                  id="phoneNo"
                  name="phoneNo"
                  placeholder="Phone Number"
                  disabled
                  fullWidth
                  variant="outlined"
                  sx={{ backgroundColor: "#E9ECEF" }}
                />
                <CustomInputLabel title={"Email Address"} isRequired={false} />
                <TextField
                  margin="dense"
                  value={email}
                  id="email"
                  name="email"
                  placeholder="example@gmail.com"
                  fullWidth
                  disabled
                  variant="outlined"
                  sx={{ backgroundColor: "#E9ECEF" }}
                />
                <Box sx={{ position: "relative" }}>
                  <CustomInputLabel title={"Profile Pic"} isRequired={false} />
                  <div className="imgUpload">
                    <img
                      className="img"
                      src={profileImg}
                      style={!profileImg ? { display: "none" } : {}}
                      alt="Profile Pic"
                    />
                    <input
                      type="file"
                      id="profilePic"
                      name="profilePic"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={(e) => handleFileChange(e)}
                    />
                    <button
                      onClick={() =>
                        document.getElementById("profilePic").click()
                      }
                    >
                      Upload Pic
                    </button>
                  </div>
                </Box>

                <CustomInput
                  name="city"
                  title="Enter City"
                  type="text"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  placeholder="enter city"
                  isRequired={false}
                  width="100%"
                />
                <CustomInput
                  name="address"
                  title="Enter Address"
                  type="text"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  placeholder="enter address"
                  isRequired={false}
                  width="100%"
                />
                <CustomInput
                  name="state"
                  title="Enter state"
                  type="text"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                  placeholder="enter state"
                  isRequired={false}
                  width="100%"
                />
                <CustomInput
                  name="postalCode"
                  title="Enter postal code"
                  type="text"
                  value={postalcode}
                  onChange={(e) => setPostalCode(e.target.value)}
                  placeholder="enter postal code"
                  isRequired={false}
                  width="100%"
                />
              </Grid>
              <Button
                variant="contained"
                size="small"
                style={{
                  backgroundColor: "#27326A",
                  width: "100%",
                  height: "40px",
                  textTransform: "none",
                  margin: "10px 0px 30px",
                }}
                onClick={() => updateSettings()}
              >
                Update Settings
              </Button>
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Grid container size={{ sm: 12, xm: 12, md: 12 }}>
              <Grid size={{ sm: 12, xs: 12, md: 12 }}>
                <h5>Reset Password</h5>
                <CustomPasswordInput
                  id="oldPassword"
                  name="oldPassword"
                  title="Old Password"
                  value={oldPassword}
                  setValue={setOldPassword}
                  required={true}
                />
                <CustomPasswordInput
                  id="newPassword"
                  name="newPassword"
                  title="New Password"
                  value={newPassword}
                  setValue={setNewPassword}
                  required={true}
                />
                <CustomPasswordInput
                  id="confirmPassword"
                  name="confirmPassword"
                  title="Confirm Password"
                  value={confirmPassword}
                  setValue={setConfirmPassword}
                  passwordMatch={passwordMatch}
                  required={true}
                />
              </Grid>
              <Button
                variant="contained"
                size="small"
                style={{
                  backgroundColor: "#27326A",
                  width: "100%",
                  height: "40px",
                  textTransform: "none",
                  margin: "10px 0px 30px",
                }}
                onClick={() => resetPassword()}
              >
                Reset Password
              </Button>
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={2}>
            Item Three
          </TabPanel>
        </Box>
      </div>

      {showAlert && (
        <Alert
          severity={alertType}
          sx={{
            position: "absolute",
            top: "100px",
            right: "20px",
            width: "300px",
          }}
        >
          {message}
        </Alert>
      )}
    </div>
  );
};

export default Settings;
